export const CAROUSEL_CONFIG = {
    cos: {
        numOfItemsPerSlide: {
            xsmall: 2,
            small: 2,
            smallPlus: 2,
            medium: 2,
            large: 2,
            xlarge: 2,
            xxl: 2,
        },
    },
    arket: {
        numOfItemsPerSlide: {
            xsmall: 2,
            small: 2,
            smallPlus: 2,
            medium: 2,
            large: 4,
            xlarge: 4,
            xxl: 4,
        },
    },
    otherStories: {
        numOfItemsPerSlide: {
            xsmall: 2,
            small: 2,
            smallPlus: 2,
            medium: 2,
            large: 2,
            xlarge: 3,
            xxl: 3,
        },
    },
};
//# sourceMappingURL=constants.js.map